import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { SettingsState, SETTINGS_SLICE_NAME } from './models';

export const settingsSelector = (state: RootState): SettingsState => state[SETTINGS_SLICE_NAME];

export const selectSettingsIsLoading = createSelector(settingsSelector, (state: SettingsState) => state.isLoading);

export const selectGeneralSettings = createSelector(settingsSelector, (state: SettingsState) => state.generalSettings);
